<template>
  <el-menu
    router
    menu-trigger="click"
    class="my-menu flex-box"
    mode="horizontal"
    background-color="transparent"
    text-color="#c1a07c"
    active-text-color="#A88D6F"
    :default-active="curPath"
    @select="handleSelect"
  >
    <template v-for="menu in menus">
      <el-submenu
        v-if="menu.children"
        :key="menu.name"
        :index="menu.path"
        :router="menu"
        :popper-append-to-body="false"
      >
        <template slot="title">{{ menu.meta.title }}</template>
        <el-menu-item
          v-for="m in menu.children"
          :key="m.name"
          :index="m.path"
          :router="m"
        >
          {{ m.meta.title }}
        </el-menu-item>
      </el-submenu>
      <el-menu-item :key="menu.name" v-else :index="menu.path" :router="menu">
        {{ menu.meta.title }}
      </el-menu-item>
    </template>
  </el-menu>
</template>

<script>
import menus from "@/router/menus";

export default {
  name: "MyHeader",
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  computed: {
    activeIndex() {
      return this.value;
    },
    curPath() {
      return this.$route.path;
    },
  },
  data() {
    return {
      menus,
    };
  },
  methods: {
    handleSelect(key) {
      this.$emit("input", key);
    },
  },
};
</script>

<style lang="less" scoped>
.my-menu {
  * {
    user-select: none !important;
  }

  &.el-menu.el-menu--horizontal {
    border-bottom: none;
  }
  ::v-deep .el-submenu.is-opened {
    .el-menu--horizontal {
      background: #fff !important;
    }
  }
}
::v-deep .el-menu-item,
.el-submenu__title {
  background: transparent !important;
}
</style>